import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react'; // @ts-expect-error

import { PropTypes as ProperTypes } from 'proper-types';
import PropTypes from 'prop-types'; // @ts-expect-error

import collectFPS from 'collect-fps';
export var AnimationControlContext = /*#__PURE__*/React.createContext({
  disableAnimations: false,
  onStartFpsCollection: function onStartFpsCollection() {}
});
export var AnimationControlConsumer = AnimationControlContext.Consumer;
export var useAnimationControl = function useAnimationControl() {
  return React.useContext(AnimationControlContext);
};

var AnimationControlProvider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AnimationControlProvider, _React$PureComponent);

  var _super = _createSuper(AnimationControlProvider);

  function AnimationControlProvider(props) {
    var _this;

    _classCallCheck(this, AnimationControlProvider);

    _this = _super.call(this, props);
    _this.state = {
      disabled: props.disableAnimations || false,
      endFpsCollection: null
    };
    _this.onStartFpsCollection = _this.onStartFpsCollection.bind(_assertThisInitialized(_this));
    _this.onEndFpsCollection = _this.onEndFpsCollection.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(AnimationControlProvider, [{
    key: "onStartFpsCollection",
    value: function onStartFpsCollection() {
      var _this$state = this.state,
          disabled = _this$state.disabled,
          endFpsCollection = _this$state.endFpsCollection;

      if (disabled === false && endFpsCollection === null) {
        try {
          this.setState({
            endFpsCollection: collectFPS()
          });
        } catch (e) {// hello darkness my old friend
        }
      }
    }
  }, {
    key: "onEndFpsCollection",
    value: function onEndFpsCollection() {
      var endFpsCollection = this.state.endFpsCollection;

      if (endFpsCollection !== null) {
        var fps = endFpsCollection();
        this.setState({
          disabled: fps < this.props.fpsThreshold
        });
      }
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      return {
        disableAnimations: this.state.disabled,
        onStartFpsCollection: this.onStartFpsCollection,
        onEndFpsCollection: this.onEndFpsCollection
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AnimationControlContext.Provider, {
        value: {
          disableAnimations: this.state.disabled,
          onStartFpsCollection: this.onStartFpsCollection,
          onEndFpsCollection: this.onEndFpsCollection
        }
      }, this.props.children);
    }
  }]);

  return AnimationControlProvider;
}(React.PureComponent);

AnimationControlProvider.displayName = 'AnimationControlProvider';
AnimationControlProvider.defaultProps = {
  disableAnimations: false,
  fpsThreshold: 30
};
AnimationControlProvider.properTypes = {
  disableAnimations: ProperTypes.bool,
  fpsThreshold: ProperTypes.number
};
AnimationControlProvider.childContextTypes = {
  // @ts-expect-error
  disableAnimations: PropTypes.bool,
  // @ts-expect-error
  onStartFpsCollection: PropTypes.func,
  // @ts-expect-error
  onEndFpsCollection: PropTypes.func
};
export default AnimationControlProvider;
//# sourceMappingURL=index.js.map